import reducer from './reducers';

export { default as locationsSelectors } from './selectors';
export { default as locationsOperations } from './operations';
export { default as locationsTypes } from './types';

export default reducer;
